<!--
    Desarrollado por: Ing. Wuilmer garcia
    // Fecha: 2021/04/04
    // Modificado por: 
    // Fecha de ultima Modificacion:    
    // Causa: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Perfil -->

        <v-form ref="formDatos" lazy-validation> 
            <v-dialog v-model="estadoComp" persistent scrollable max-width="60%">
                <v-card>
                    <v-card-title class="modal_title">
                        <v-row class="d-flex justify-space-between py-2"> 
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title> 

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row>


                            
                            <v-col cols="12" sm="12" md="6">
                                <v-select label="Categoría" v-model="Datos.id_categoria"
                                    :items="Categoria" item-value="id" item-text="desc_documento_categoria"
                                    repend-icon="fa-flag" :rules="[validation.selectReq]"> 
                                </v-select>
                            </v-col>


                            <v-col cols="12" sm="12" md="6">
                                <v-text-field v-model="Datos.desc_documento" label="Descripción" :rules="[validation.required, validation.max100]"></v-text-field>
                            </v-col>
                                                                        
       
                            <v-col cols="12" sm="12" md="6" class="py-0">
                                <v-menu v-model="menuFec" :close-on-content-click="false"
                                    transition="scale-transition" offset-y
                                    max-width="290px" min-width="290px" >

                                    <template v-slot:activator="{ on }">
                                        <v-text-field label="Fecha Inicio" v-model="computedDateFormatted"
                                            prepend-icon="fa-calendar-alt" 
                                            readonly v-on="on" :rules="[validation.required]">
                                        </v-text-field>
                                    </template>

                                    <v-date-picker v-model="Datos.fecha_inicio" 
                                        no-title @input="menuFec = false" :min="maxDate"></v-date-picker>
                                </v-menu>
                        
                            </v-col>

                            <v-col cols="12" sm="12" md="6" class="py-0" >
                                <v-radio-group v-model="Datos.estado_documento" label="Estado" row>
                                    <v-radio :label="`Activo`" :value="true" color="teal"></v-radio>
                                    <v-radio :label="`Inactivo`" :value="false" color="error"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>




                        <v-row class="mx-2">
                            <v-col cols="12">
                                <div>   
                                    <h2>Selecione Documento</h2> 
                                    <input type="file" name="subirArchivo" ref="myFileImagen" @change="onFileChange" accept=".doc,.docx,.pdf,.xls" > 
                                
                                    <v-btn v-if="fileDoc" class="btn_eliminar float-right" fab x-small title="Eliminar" @click="removeDoc">
                                        <v-icon>fa-trash-alt</v-icon>
                                    </v-btn> 
                                </div> 
                                
                            </v-col>
                      
                        </v-row>


                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" :disabled="disabledButton" tile @click="$emit('close')">Cancelar</v-btn>
                        <v-btn class="btn_block_style2" :disabled="disabledButton"  :loading="loading" tile @click="saveItem">{{saveText}}</v-btn>
 

                    </v-card-actions>

                        <span v-if="test">
                            <code>parametros :{{parametros}} </code> 
                            <code>Datos:  {{Datos}} </code>
                            <code>Datos Session {{JSON.stringify(session)}}</code>
                        </span>
                     </v-card>
               
            </v-dialog>


           
        </v-form>

        <!-- fin modal del Colegio -->



    </div>
</template>

<script>

    import axios from "@/helpers/axios";
    import { validation } from "@/helpers/validator.js";
    import {mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name:'DocumentoFormulario',

        // props:['estadoComp' , 'parametros'],
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },



        data(){
            return{
                session: sessionStorage,
                test:false,
                Datos: [],
                saveText : "undefined",
                disabledButton: false,
                loading:false,
               
                menuFec: false,  
                Categoria:[],


                  // Variables para la imagen

                fileDoc: '',
                API_URL: 'http://localhost:8080/', 
                //rutaServer: API_URL,

                inhabilitarButton:false,
            }
        },
       
        mounted() {  
             this.loadMain()
        },

        //computadas
        computed: {
         
            ...mapGetters('login', [ 'componenteEvento']),
           
            formTitle () {
                return this.parametros.evento === 'agregar' ? 'Crear Documento' : 'Editar Documento'
            },

            validation() {
                return validation;
            },


            // Maxima Fecha Calendario
            maxDate(){
                return  new Date().toISOString().substr(0, 10)               
            },
            
            computedDateFormatted () {
                return this.formatDate(this.Datos.fecha_inicio)
            },

                   
        },

        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()
                 
                }
            }
        },
        

        methods: {

            ...mapActions('login',['parametroComponente'] ),
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            
            formatDate (date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },

            async loadMain(){

                this.limpiarForm() 
                // this.$refs.formDatos.resetValidation()
                if(this.parametros.evento=='agregar'){
                    this.saveText = "Guardar"                    
                }
                
                if(this.parametros.evento=='editar'){
                    this.saveText = "Guardar Cambios"
                    this.editItem(this.parametros.item) 
                }


                try{
                    let params ={id_empresa: this.session.id_empresa, estado_documento_categoria :true }
                    let response = await axios.post("/website/docCategoria/get",{filtro:params})
                    this.Categoria = response.data;
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }

            },

        
            editItem (item) {                
                this.Datos  =item        
            },


            limpiarForm(){


                this.Datos = {
                    id_usuario: this.session.id, id_empresa: this.session.id_empresa,
                    id:-1, id_categoria: "", desc_documento:"", ruta_documento:"", extension_documento:"",
                    fecha_inicio:"", orden_documento: -1,  estado_documento :true
                }

                this.resetValidation()
            },

            // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formDatos.resetValidation()
            },




            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.fileDoc =  files[0]                
                // this.createImage(files[0]);
                console.log(files[0])

            },

            /*
            cargarPrevia(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.nombreArchivo =  files[0]
                if(this.nombreArchivo != ''){
                    this.existeArchivo = true
                    
                }
                console.log(this.nombreArchivo)
            },  */


                
            removeDoc(){                
                this.fileDoc  = ''
                this.myFileImagen.files= ""
            },


            // Guarda DOCUMENTO
            async saveItem(){
                if (this.$refs.formDatos.validate()) {
                    try{
                        this.disabledButton = true
                        this.loading =true

                      this.inhabilitarButton= true
                        // let  res = ""
                        //let imagenLoad = ""
                        if(this.fileDoc == "" && this.parametros.evento == "agregar"){

                            this.setEnviarMens({tipo: "E", mensaje: `Debe de Ingresar un Documento`, tiempo:null})
                            this.disabledButton = false
                            this.loading =false
                            return false
                        }


                            /*

                            imagenLoad = await this.saveDocumento();
                            console.log(`Imagen Cargada: ${JSON.stringify(imagenLoad)}`)
                            this.Datos.img_nombre = imagenLoad.nombreArchivo                                
                            this.Datos.img_ruta   = imagenLoad.uri
                            console.log(`Guardar Imagen`)

                            if(imagenLoad.messageT=="E" ){

                                this.setEnviarMens({tipo: imagenLoad.messageT, mensaje: `${imagenLoad.message}`, tiempo:null})
                                return false
                            }

                            */

                        let resp = {}
                        if(this.parametros.evento == "agregar"){
                            let response =  await axios.post("/website/documento",this.Datos)
                            resp = response.data
                            this.Datos.id = resp.data.id
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                        
                        }

                        if(this.parametros.evento == "editar"){
                            await axios.put("/website/documento/"+this.Datos.id,this.Datos)
                            this.setEnviarMens({tipo:"S", mensaje: `Registro guardado con éxito`, tiempo:null})
                        }

                        console.log(`respuesta del server ${JSON.stringify(resp)}`)


                        if(this.fileDoc){
                            this.saveDocumento();
                        }

                        this.limpiarForm()
                        this.disabledButton = false
                        this.loading =false
                        this.$emit('reloadComp','documento')
                    }

                    catch(e){
                        if (e.response) {
                            this.disabledButton = false
                            this.loading =false
                            let resp = e.response.data
                            console.log(resp)
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                        }
                    }
                }else{
                    this.setEnviarMens({tipo: "W", mensaje: `Debe de Ingresar todos los Datos`, tiempo:null})
                    this.disabledButton = false
                    this.loading =false
                }

            },




            async saveDocumento(){

                let formData = new FormData();
                formData.append('subirArchivo', this.fileDoc)
                formData.append('id',this.Datos.id)
                formData.append('id_cliente', this.Datos.id_empresa)
                formData.append('id_categoria', this.Datos.id_categoria)
                formData.append('archivo_old', this.Datos.ruta_documento)
                formData.append('id_usuario', this.session.id)
               
                


                try{

                        let resp  = await axios.post(`website/archivo/documento/cliente/${this.Datos.id_empresa}`, formData,
                        {
                            headers: {'Content-Type': 'multipart/form-data' }
                        })

                    this.setEnviarMens({tipo: resp.data.messageT, mensaje: resp.data.message, tiempo:null})   

                    /*
                    let resp = ""
                    if(this.parametros.evento == "agregar"){

                        resp  = await axios.post('archivo/galleryCont', formData,
                                {
                                    headers: {'Content-Type': 'multipart/form-data' }
                                })

                    }else if (this.parametros.evento == "editar") {
                        
                    resp  = await axios.put('archivo/galleryCont', formData,
                                {
                                    headers: {'Content-Type': 'multipart/form-data' }
                                })

                    } else {
                     
                        return false
                    }
                    
                    //this.setEnviarMens({tipo: resp.data.messageT, mensaje: resp.data.message, tiempo:null})      
                    //console.log(`Imagen Subida Galleria: ${resp.data}`)
                    return resp.data
                    */
                } catch(e){

                    console.log(e)
                    this.setEnviarMens({tipo:"E", mensaje: `Error en Subir Imagen`, tiempo:null})       
                    return false           

                }
                
            },
   



          

        },
    }
</script>


<style scoped>
</style>